import { ChangeEvent, FC } from 'react'

import { FieldMetadata, useInputControl } from '@conform-to/react'
import { z } from 'zod'

import { TextInput } from '~/components'
import { SearchFormSectionLayout } from '~/features/common/search-form-sections/section-layout'

// NOTE: onという文字列が入力された場合、booleanで処理されてしまうので文字列として返す
export const keywordsSchema = z.object({
  keyword: z.string().max(32).optional(),
})

type KeywordsType = z.infer<typeof keywordsSchema>['keyword']

export const partialKeywordsSchema = keywordsSchema.partial()

export const useKeywordForm = (
  meta: FieldMetadata<KeywordsType>,
  changeWatchedKeyword?: (keyword: string) => void,
) => {
  const keywordControl = useInputControl({
    ...meta,
    initialValue: meta.initialValue ?? '',
  })
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    keywordControl.change(e.target.value)
  }

  const value = keywordControl.value
  const onEnterKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      changeWatchedKeyword?.(value || '')
    }
  }

  const onBlur = () => {
    changeWatchedKeyword?.(value || '')
  }

  return {
    value: keywordControl.value || '',
    onChange,
    onEnterKeyDown,
    onBlur,
    name: meta.name,
  }
}

type KeywordsSectionProps = {
  value: string
  name: string
  errorMessages?: string[]
  headerClassName?: string
  layoutClassName?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onEnterKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onBlur?: () => void
}

export const KeywordsSection: FC<KeywordsSectionProps> = ({
  errorMessages,
  layoutClassName,
  headerClassName,
  value,
  onChange,
  onEnterKeyDown,
  name,
  onBlur,
}) => {
  return (
    <SearchFormSectionLayout
      headerClassName={headerClassName}
      layoutClassName={layoutClassName}
      title="キーワード"
    >
      <div className="grow p-4 pb-0 md:pb-4">
        <TextInput
          className="w-full"
          defaultValue={value}
          errorMessages={errorMessages}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onKeyDown={onEnterKeyDown}
          placeholder="駅名・物件名など"
        />
      </div>
    </SearchFormSectionLayout>
  )
}
